/** The ● ○ ○ progress dots at the top of the join screens (docs/06-UI-SPEC.md §4). */

export interface ProgressDotsProps {
  readonly total: number;
  /** 1-based. */
  readonly current: number;
}

export function ProgressDots({ total, current }: ProgressDotsProps) {
  return (
    <div className="flex items-center gap-3" aria-label={`Step ${current} of ${total}`}>
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          aria-hidden="true"
          className={`h-3 w-3 rounded-full ${
            index + 1 === current ? 'bg-primary' : 'bg-border-strong'
          }`}
        />
      ))}
    </div>
  );
}
